// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__lxOW7","dots-btn":"Header_dots-btn__LzrcG","header-inner":"Header_header-inner__I25Bm"};